import React from "react";
import "./HomeCTA.scss";
import CustomButton from "../../shared/custom-button/custom-button";
import { Link } from "react-router-dom";

const HomeCTA = () => {
  return (
    <section className="home-cta-wrapper">
      <div className="home-cta-container">
        <div className="cta-left-group">
          <div className="cta-image-section">
            <img
              src="/images/services/management-consulting/cta.webp"
              alt="Business Analytics"
            />
            <div className="image-overlay" />
          </div>
          <div className="cta-content-section">
            <h5>Let's build clarity around your next move.</h5>
          </div>
        </div>
        <div className="cta-action-section">
          <CustomButton as={Link} to="/contact">
            Request a Consultation
          </CustomButton>
        </div>
      </div>
    </section>
  );
};

export default HomeCTA;
